(ns rothko.collection-components.filters.component
  (:require [medley.core :refer [map-vals]]
            [rothko.form2.component :as form]
            [rothko.collection-components.core :as collection]))

(defn filter-form-on-change
  [{:keys [::on-change] :as props}
   !collection-component-state
   {:keys [::form/value ::form/id ::form-value->filter-param]}]
  (let [old-state @!collection-component-state
        state (swap! !collection-component-state update :filters
                     (fn [filters]
                       (assoc filters
                              id (if form-value->filter-param
                                   (form-value->filter-param value)
                                   value))))
        filter-values #(->> % :filters vals (remove nil?))]
    (when (not= (filter-values old-state) (filter-values state))
      (on-change state))))

(defn form
  [{:keys [::collection/fields] :as props}
   !collection-component-state
   collection-component]
  (let [on-field-change (partial filter-form-on-change props !collection-component-state)
        filter-form-fields (into {}
                                 (comp
                                  (map ::filter)
                                  (remove nil?)
                                  (map (juxt ::form/id identity)))
                                 fields)
        initial-form-value (:filters @!collection-component-state)]
    [form/form
     {::form/initial-value initial-form-value
      ::form/render-props props
      ::form/on-field-change on-field-change}
     filter-form-fields
     collection-component]))
